/** @jsx jsx */
import { Box, jsx, Text } from 'theme-ui'

const CartMeter = ({ label, percentage, footer }) => {
  return (
    <Box
      bg="backgroundMedium"
      px={[2, 3]}
      pt={[1, '12px']}
      pb={2}
      sx={{ textAlign: 'center' }}
    >
      <Text as="p" pb={1} variant="body3">
        {label}
      </Text>
      <Box
        sx={{
          border: '1px solid rgba(240, 105, 92, 0.5)',
          borderRadius: '6px',
          height: '14px',
          p: '3px 4px',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'brandTertiary',
            borderRadius: '6px',
            height: '100%',
            transition: 'width 0.3s ease-in-out',
            width: `${percentage}%`,
          }}
        />
      </Box>
      {footer && <Box mt={1}>{footer}</Box>}
    </Box>
  )
}

export default CartMeter
